'use client';
import { useEffect } from 'react';
import { signalPrerenderReady } from '@/utils/prerender';

export const PrerenderReady = () => {
  useEffect(() => {
    signalPrerenderReady(); // no-op outside prerender context
  }, []);
  return null;
};
